var map = {
	"./activities.svg": 24918,
	"./add.svg": 17812,
	"./arrow-down.svg": 18219,
	"./arrow-left.svg": 2696,
	"./arrow-received.svg": 25002,
	"./arrow-right-red.svg": 53426,
	"./arrow-right.svg": 49613,
	"./arrow-sent.svg": 90824,
	"./arrow-up.svg": 63944,
	"./arrows-crossed.svg": 11234,
	"./back-arrow.svg": 37606,
	"./back-step.svg": 96104,
	"./back.svg": 16281,
	"./barcode.svg": 685,
	"./burger-menu.svg": 21100,
	"./button-photo.svg": 55978,
	"./cancel-red.svg": 73157,
	"./cancel.svg": 65014,
	"./close.svg": 89436,
	"./collections.svg": 21795,
	"./contact-add.svg": 45523,
	"./contact-us.svg": 57496,
	"./contact.svg": 7620,
	"./copy.svg": 59100,
	"./creation.svg": 69877,
	"./current-step.svg": 2246,
	"./delete-warning.svg": 13452,
	"./delete.svg": 37181,
	"./done-blue.svg": 91346,
	"./download-android.svg": 80488,
	"./download-ios.svg": 65771,
	"./email.svg": 51246,
	"./face-id.svg": 91300,
	"./flag-france.svg": 88272,
	"./grid-display.svg": 37510,
	"./history-active.svg": 32226,
	"./history.svg": 4106,
	"./home-active.svg": 69987,
	"./home.svg": 27442,
	"./hourglass.svg": 81118,
	"./languages/de.svg": 84934,
	"./languages/en.svg": 4867,
	"./languages/es.svg": 4249,
	"./languages/fr.svg": 84643,
	"./languages/nl.svg": 29293,
	"./languages/pt.svg": 64414,
	"./languages/zh.svg": 89506,
	"./left-arrow.svg": 73700,
	"./line-right.svg": 52474,
	"./list-display.svg": 38248,
	"./locked-padlock.svg": 63679,
	"./logo.svg": 37555,
	"./logout.svg": 45609,
	"./messages-active.svg": 24617,
	"./messages.svg": 58462,
	"./mint.svg": 81507,
	"./nft.svg": 2116,
	"./notifications.svg": 95496,
	"./pencil.svg": 20182,
	"./phone.svg": 83159,
	"./photo.svg": 10589,
	"./picture.svg": 51482,
	"./profile.svg": 52753,
	"./qr-code.svg": 47310,
	"./qrcode.svg": 26868,
	"./receive.svg": 42975,
	"./refresh.svg": 70852,
	"./repair.svg": 51784,
	"./retry.svg": 80125,
	"./scan.svg": 62982,
	"./search.svg": 86537,
	"./send-success.svg": 62702,
	"./send.svg": 9620,
	"./setting-warning.svg": 53538,
	"./settings-active.svg": 71736,
	"./settings.svg": 44364,
	"./sms.svg": 65688,
	"./spaces-active.svg": 62073,
	"./spaces.svg": 97792,
	"./success.svg": 23643,
	"./terms-and-conditions.svg": 31489,
	"./touch-id.svg": 26527,
	"./transfer.svg": 83086,
	"./trash.svg": 59329,
	"./unlocked-padlock.svg": 45718,
	"./update.svg": 31199,
	"./user-active.svg": 82583,
	"./user.svg": 98793,
	"./wallet-old.svg": 69914,
	"./wallet.svg": 72250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30636;